import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";

import Payment from "views/pages/subscription/component/payment/Payment";
import { ContractType } from "views/pages/subscription/component/ComponentWidget";
import { MDetailOthers, MDetailPackage, MDetailPeriod, MDetailPrime, MDetailStartDate } from "../../common/details";
import { useBasket } from "views/pages/subscription/hooks/useBasket";
import _ from "lodash";

const StepDetailsLite=({
    endDate,
    subscriptionRequest,
    packSelected
})=> {

    const {goToPreviousStep, updatePaymentStatus: paymentStatus, initStartDate, setInitStartDate, onStartDateChange }=useBasket();
    
    useEffect(()=> {
        setInitStartDate({
            startDate: subscriptionRequest?.dateEffect,
            endDate: endDate,
            initialDate: subscriptionRequest?.customerStartDate ?? subscriptionRequest?.dateEffect
        });
    }, [])

    const getGuaranties=()=> {
        if(_.size(packSelected?.customGuaranties) <= 0) return packSelected?.guaranties;
        else {
            const customGuarantiesRef = (packSelected?.customGuaranties || []).map((customGuarantee)=> customGuarantee?.guaranteeRef);
            return (packSelected?.guaranties || [])?.filter((guarantee)=> customGuarantiesRef.includes(guarantee?.ref))
        }
    }

    return(
        <React.Fragment>
            <div /* className="page-content" */>
                <Container fluid>                    
                    
                    <Row>
                        <Col className="col-xxl-9 order-xxl-0 order-first">
                            <Row>
                                <MDetailPackage packTitle={packSelected?.packTitle}/>

                                <MDetailPeriod perioTitle={packSelected?.period?.title} />

                                <MDetailStartDate 
                                    editable={false}
                                    rangeDate={initStartDate} 
                                    onStartDateChange={onStartDateChange} />

                            </Row>
                            <MDetailOthers
                                defaultTab={"2"}
                                guaranties={getGuaranties()}
                                assure={subscriptionRequest?.assure}
                            />
                        </Col>
                        <MDetailPrime 
                            primeTTC={packSelected?.primeTTC}
                            primeNette={packSelected?.primeNette}
                            extras={packSelected?.extras}
                            />
                        
                    </Row>
                    <Row>
                        <Col className="col-xxl-12">
                            <Payment 
                                    backVisibility={true}
                                    projectVisibility={true}
                                    onlineVisiblity={true}
                                    payload={subscriptionRequest}
                                    paymentStatus={paymentStatus}
                                    goBack={goToPreviousStep}
                                    type={ContractType.MONO}
                                />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default StepDetailsLite;